import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.title')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.saveAlerts
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0 alert-config",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "alertForm",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.unsavedTitle'),
      "open": _vm.unsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-parser'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.unsavedPrompt = false;
      },
      "discard-parser": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.unsavedText')) + "\n      ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.text'))
    }
  }), _vm.alertConfigs.length === 0 ? [!_vm.isLoading ? [_c(VRow, {
    attrs: {
      "align": "top"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addNewAlert(-1);
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n            ")])], 1)] : [_c(VRow, {
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1)], 1), _c(VRow, {
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSkeletonLoader, {
    attrs: {
      "type": "heading"
    }
  })], 1)], 1)]] : _vm._e(), _vm._l(_vm.alertConfigs, function (alert, i) {
    return _c('niota-classic-gw-mgmt-alert-config', {
      key: `alert_${i}`,
      attrs: {
        "formItem": alert,
        "bridges": _vm.mailBridges
      },
      on: {
        "add": function ($event) {
          return _vm.addNewAlert(i);
        },
        "delete": function ($event) {
          return _vm.removeAlert(i);
        }
      }
    });
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };